// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"award-toggle__list--2y59c","item":"award-toggle__item--U5g9B","link":"award-toggle__link--1yG4I","active":"award-toggle__active--mkTPb"};